export function isLastBarVisibleInExtents(xExtents, lastBarIndex) {
  if (!xExtents || !Array.isArray(xExtents) || xExtents.length !== 2)
    return false;
  if (lastBarIndex === null || lastBarIndex === undefined) return false;

  const [start, end] = xExtents;
  return lastBarIndex >= start && lastBarIndex <= end;
}

export function shiftXExtentsByBars(xExtents, barsDelta) {
  if (!xExtents || !Array.isArray(xExtents) || xExtents.length !== 2)
    return xExtents;
  if (!barsDelta) return xExtents;

  const [start, end] = xExtents;
  return [start + barsDelta, end + barsDelta];
}

export function getHorizontalState(xExtents, lastBarIndex) {
  return isLastBarVisibleInExtents(xExtents, lastBarIndex)
    ? "aligned"
    : "displaced";
}
